import { Card, Button } from "react-bootstrap";

import "./TournoisListe.css";
import { useSelector } from "react-redux";
import { selectFirstTournaments } from "../../../../../Store/tournametsSlice";
import { NavLink, useNavigate } from "react-router-dom";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect } from "react";

export default function TournoisListe() {
  const navigate = useNavigate();
  const tournaments = useSelector(selectFirstTournaments);
  const settings = {
    dots: true,
    infinite: tournaments.length > 3,
    speed: 1500,
    slidesToShow: Math.min(3, tournaments.length),
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 9000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: Math.min(3, tournaments.length),
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: Math.min(2, tournaments.length),
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: Math.min(1, tournaments.length),
        },
      },
    ],
  };
  return (
    <>
      {tournaments.length < 1 ? (
        <div className="tournament-empty">
          🎾 Aucun tournoi en cours pour le moment !
        </div>
      ) : (
        <>
          <Slider {...settings} className="container-fluid text-center">
            {tournaments.map((tournament, index) => (
              <Card key={index} className="tournament_card">
                <Card.Body>
                  <Card.Title>{tournament.title}</Card.Title>
                  <Card.Img
                    variant="top"
                    src={tournament.picture}
                    style={{ marginBottom: "10px" }}
                  />
                  <button
                    className="col-12 primary-btn"
                    onClick={() =>
                      navigate("/tournois/event/" + tournament._id)
                    }
                  >
                    En Savoir Plus
                  </button>
                </Card.Body>
              </Card>
            ))}
          </Slider>
          <div className="tournament-see-all">
            <NavLink to="/tournois">Voir Tous les Tournois</NavLink>
          </div>
        </>
      )}
    </>
  );
}
